export enum GeneratedFileTypes{
	TS = "TS",
	HTML = "HTML",
	CSS = "CSS"
}